import type { TimeRangePickerProps } from 'antd';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { toDayjs } from '~/utils/datetime';
const { RangePicker } = DatePicker;

const rangePresets: TimeRangePickerProps['presets'] = [
  { label: 'Today', value: [dayjs().add(0, 'd'), dayjs()] },
  { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs()] },
  { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
  { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
];

interface ICustomDateRangePickerProps {
  onChange(startDate: string, endDate: string): void;
  onClear(): void;
  value: null | Array<string>;
}

const CustomDateRangePicker = ({ onChange, onClear, value }: ICustomDateRangePickerProps) => {
  const onRangeChange = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
    if (dates) {
      onChange(dateStrings[0], dateStrings[1]);
    } else {
      onClear();
    }
  };

  return (
    <RangePicker
      value={value === null ? value : [toDayjs(value[0]), toDayjs(value[1])]}
      className="customDateInput"
      presets={rangePresets}
      onChange={onRangeChange}
    />
  );
};

export default CustomDateRangePicker;
